module.exports = __webpack_public_path__ + "img/14.2e9cf444.jpg";